import * as React from 'react'
import DatePicker, { registerLocale } from 'react-datepicker-styled-components'
import { colors } from '../../../styleConstants'
import styled from 'styled-components'
import cc from 'classcat'
import ja from 'date-fns/locale/ja'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  readonly locale: string
  readonly enterDateTime: Date
  readonly fluid?: boolean
  readonly className?: string
  readonly style?: React.CSSProperties
  readonly onChanged?: (date: any) => void
}

export default function ConciergeDateTimePicker({ locale, enterDateTime, fluid, onChanged }: Props) {
  const initialDate = enterDateTime ? enterDateTime : new Date()
  const [startDate, setStartDate] = React.useState(initialDate)
  const handleChange = (date: any) => {
    setStartDate(date)
    if (onChanged) {
      onChanged(date)
    }
  }

  if (locale == 'ja') {
    registerLocale(locale, ja)
  }

  return (
    <Container className={cc([{ fluid }])}>
      <EnterDateTime
        locale={locale}
        selected={startDate}
        onChange={handleChange}
        dateFormat="yyyy/MM/dd HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={30}
        required
        />
    </Container>
  )
}

const Container = styled.div`
  display: inline-flex;
  color: ${colors.gray800};
  position: relative;
  
  &.fluid {
    display: flex;
  }

  [data-icon='right'] {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

const EnterDateTime = styled(DatePicker)`
  width: 25em;
  flex: 1 0 auto;
  max-width: 100%;
  outline: 0;
  border-radius: 4px;
  box-shadow: none;
  color: ${colors.gray800};
  background: ${colors.white};
  border: 1px solid ${colors.gray300};
  padding: 0.5rem;

  &:active,
  &:focus {
    border: 1px solid ${colors.secondary};
  }

  &:empty:required {
    border: 1px solid ${colors.gray300};
  }

  &:invalid {
    border: 1px solid ${colors.error};
  }
`